import { ElementType } from 'react'
import DashboardIcon from '@rsuite/icons/legacy/Dashboard'
import UserIcon from '@rsuite/icons/legacy/User'
import QuoteRightIcon from '@rsuite/icons/legacy/QuoteRight'
import CreditCardIcon from '@rsuite/icons/legacy/CreditCard'
import TagIcon from '@rsuite/icons/legacy/Tag'
import ShieldIcon from '@rsuite/icons/legacy/Shield'
import CogsIcon from '@rsuite/icons/legacy/Cogs'
import StarIcon from '@rsuite/icons/legacy/Star'
import BarChartIcon from '@rsuite/icons/legacy/BarChart'
import CarIcon from '@rsuite/icons/legacy/Car'
import BuildingIcon from '@rsuite/icons/legacy/Building'
import PeoplesIcon from '@rsuite/icons/legacy/Peoples'
import SendIcon from '@rsuite/icons/legacy/Send'
import IdCardIcon from '@rsuite/icons/legacy/IdCard'
import SignInIcon from '@rsuite/icons/legacy/SignIn'
import BanIcon from '@rsuite/icons/legacy/Ban'
import UserAnalysisIcon from '@rsuite/icons/legacy/UserAnalysis'
import ListIcon from '@rsuite/icons/legacy/List'
import LockIcon from '@rsuite/icons/legacy/Lock'
import Question2Icon from '@rsuite/icons/legacy/Question2'
import { ROLES_TYPE } from 'utils'

export type MenuSectionKey =
  | 'main'
  | 'management'
  | 'configuration'
  | 'vehicleData'
  | 'setting'

export type MenuItemType = {
  id: string
  name: string
  link: string
  icon: ElementType
  section: MenuSectionKey
  roles: string[]
}

export type MenuSectionType = {
  id: MenuSectionKey
  title: string
  items: MenuItemType[]
}

export const menuItems: MenuItemType[] = [
  {
    id: 'main-dashboard',
    name: 'Dashboard',
    link: '/dashboard',
    icon: DashboardIcon,
    section: 'main',
    roles: [
      ROLES_TYPE.ADMIN,
      ROLES_TYPE.AGENT,
      ROLES_TYPE.USER,
      ROLES_TYPE.SUPERADMIN
    ]
  },
  {
    id: 'management-users',
    name: 'Users',
    link: '/admin/users',
    icon: UserIcon,
    section: 'management',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'management-quotes',
    name: 'Quotes',
    link: '/admin/quotes',
    icon: QuoteRightIcon,
    section: 'management',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'management-payments',
    name: 'Payments',
    link: '/admin/payments',
    icon: CreditCardIcon,
    section: 'management',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'management-policies',
    name: 'Policies',
    link: '/admin/policies',
    icon: ShieldIcon,
    section: 'management',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'management-payout-requests',
    name: 'Payout Requests',
    link: '/admin/payout-requests',
    icon: SendIcon,
    section: 'management',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'management-enquiries',
    name: 'Enquiries',
    link: '/admin/enquiries',
    icon: Question2Icon,
    section: 'management',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'setting-account-status',
    name: 'Account Status',
    link: '/admin/account-status',
    icon: UserAnalysisIcon,
    section: 'setting',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'setting-audit-history',
    name: 'Audit History',
    link: '/admin/audit-history',
    icon: CogsIcon,
    section: 'setting',
    roles: [ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'setting-ip-blocks',
    name: 'IP Blocks',
    link: '/admin/ip-blocks',
    icon: BanIcon,
    section: 'setting',
    roles: [ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'setting-login-attempts',
    name: 'Login Attempts',
    link: '/admin/login-attempts',
    icon: SignInIcon,
    section: 'setting',
    roles: [ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'setting-request-journal',
    name: 'Request Journal',
    link: '/admin/request-journal',
    icon: ListIcon,
    section: 'setting',
    roles: [ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'setting-app-settings',
    name: 'Settings',
    link: '/admin/settings',
    icon: CogsIcon,
    section: 'setting',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'setting-privacy-settings',
    name: 'Account Privacy',
    link: '/setting/privacy',
    icon: LockIcon,
    section: 'setting',
    roles: [ROLES_TYPE.USER, ROLES_TYPE.AGENT]
  },
  {
    id: 'configuration-categories',
    name: 'Insurance Products',
    link: '/admin/insurance-products',
    icon: TagIcon,
    section: 'configuration',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'configuration-coverage-options',
    name: 'Coverage Options',
    link: '/admin/coverage-options',
    icon: ShieldIcon,
    section: 'configuration',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'configuration-coverage-benefits',
    name: 'Coverage Benefits',
    link: '/admin/coverage-benefits',
    icon: StarIcon,
    section: 'configuration',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'configuration-coverage-rates',
    name: 'Coverage Rates',
    link: '/admin/coverage-rates',
    icon: BarChartIcon,
    section: 'configuration',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'configuration-plans',
    name: 'Plans',
    link: '/admin/plans',
    icon: CogsIcon,
    section: 'configuration',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'configuration-underwriters',
    name: 'Underwriters',
    link: '/admin/underwriters',
    icon: BuildingIcon,
    section: 'configuration',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'vehicle-data-vehicles',
    name: 'Vehicles',
    link: '/admin/vehicles',
    icon: CarIcon,
    section: 'vehicleData',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'user-quotes',
    name: 'Quotes',
    link: '/user/quotes',
    icon: QuoteRightIcon,
    section: 'management',
    roles: [ROLES_TYPE.USER]
  },
  {
    id: 'user-policies',
    name: 'Policies',
    link: '/user/policies',
    icon: ShieldIcon,
    section: 'management',
    roles: [ROLES_TYPE.USER]
  },
  {
    id: 'user-payments',
    name: 'Payments',
    link: '/user/payments',
    icon: CreditCardIcon,
    section: 'management',
    roles: [ROLES_TYPE.USER]
  },
  {
    id: 'agent-customers',
    name: 'Customers',
    link: '/agent/customers',
    icon: PeoplesIcon,
    section: 'management',
    roles: [ROLES_TYPE.AGENT]
  },
  {
    id: 'agent-quotes',
    name: 'Quotes',
    link: '/agent/quotes',
    icon: QuoteRightIcon,
    section: 'management',
    roles: [ROLES_TYPE.AGENT]
  },
  {
    id: 'agent-policies',
    name: 'Policies',
    link: '/agent/policies',
    icon: ShieldIcon,
    section: 'management',
    roles: [ROLES_TYPE.AGENT]
  },
  {
    id: 'agent-payments',
    name: 'Payments',
    link: '/agent/payments',
    icon: CreditCardIcon,
    section: 'management',
    roles: [ROLES_TYPE.AGENT]
  },
  {
    id: 'agent-payouts',
    name: 'Payouts',
    link: '/agent/payouts',
    icon: SendIcon,
    section: 'management',
    roles: [ROLES_TYPE.AGENT]
  },
  {
    id: 'user-emi',
    name: 'EMI Schedules',
    link: '/user/emi',
    icon: BarChartIcon,
    section: 'management',
    roles: [
      ROLES_TYPE.USER,
      ROLES_TYPE.AGENT,
      ROLES_TYPE.ADMIN,
      ROLES_TYPE.SUPERADMIN
    ]
  },
  {
    id: 'user-profile',
    name: 'Profile',
    link: '/user/profile',
    icon: UserIcon,
    section: 'management',
    roles: [ROLES_TYPE.USER]
  },
  {
    id: 'agent-kyc',
    name: 'KYC Management',
    link: '/agent/kyc',
    icon: IdCardIcon,
    section: 'management',
    roles: [ROLES_TYPE.AGENT]
  },
  {
    id: 'agent-logbooks',
    name: 'Logbooks',
    link: '/agent/logbooks',
    icon: CarIcon,
    section: 'management',
    roles: [ROLES_TYPE.AGENT]
  },
  {
    id: 'agent-profile',
    name: 'Profile',
    link: '/agent/profile',
    icon: UserIcon,
    section: 'management',
    roles: [ROLES_TYPE.AGENT]
  },
  {
    id: 'admin-kyc',
    name: 'KYC Management',
    link: '/admin/kyc',
    icon: IdCardIcon,
    section: 'management',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  },
  {
    id: 'admin-logbooks',
    name: 'Logbooks',
    link: '/admin/logbooks',
    icon: CarIcon,
    section: 'management',
    roles: [ROLES_TYPE.ADMIN, ROLES_TYPE.SUPERADMIN]
  }
]

const menuSectionOrder: Array<{ id: MenuSectionKey; title: string }> = [
  { id: 'main', title: 'Main' },
  { id: 'management', title: 'Management' },
  { id: 'configuration', title: 'Configuration' },
  { id: 'vehicleData', title: 'Vehicle Data' },
  { id: 'setting', title: 'Settings' }
]

const parseRoles = (role: string): string[] =>
  role
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)

const normalizePath = (path: string): string => {
  if (!path) return ''
  const sanitizedPath = path.split('#')[0].split('?')[0]
  if (sanitizedPath.length > 1 && sanitizedPath.endsWith('/')) {
    return sanitizedPath.slice(0, -1)
  }
  return sanitizedPath
}

const hasRoleAccess = (roles: string[], role: string): boolean => {
  const userRoles = parseRoles(role)
  return roles.some((allowedRole) => userRoles.includes(allowedRole))
}

export const getMenuItemsForRole = (role: string): MenuItemType[] => {
  if (!role) return []
  return menuItems.filter((item) => hasRoleAccess(item.roles, role))
}

export const getMenuSectionsForRole = (role: string): MenuSectionType[] => {
  const items = getMenuItemsForRole(role)
  return menuSectionOrder
    .map((section) => ({
      ...section,
      items: items.filter((item) => item.section === section.id)
    }))
    .filter((section) => section.items.length > 0)
}

export const getMenuItemByPath = (
  pathname: string,
  role: string
): MenuItemType | undefined => {
  const normalizedPathname = normalizePath(pathname)
  return getMenuItemsForRole(role).find(
    (item) => normalizePath(item.link) === normalizedPathname
  )
}
